import React, { useEffect, useState } from "react";
import OwlCarousel from 'react-owl-carousel';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import wallImage from '../assets/img/exam/wall_1.png'

const wallOfFameData = [
  {
    name: 'Ram Balaji',
    title: 'AIR 1|GATE EC 2022',
    image: wallImage,
  },
  {
    name: 'Ram Balaji',
    title: 'AIR 1|GATE EC 2022',
    image: wallImage,
  },
  {
    name: 'Ram Balaji',
    title: 'AIR 1|GATE EC 2022',
    image: wallImage,
  },
  {
    name: 'Ram Balaji',
    title: 'AIR 1|GATE EC 2022',
    image: wallImage,
  },
  {
    name: 'Ram Balaji',
    title: 'AIR 1|GATE EC 2022',
    image: wallImage,
  },
  {
    name: 'Ram Balaji',
    title: 'AIR 1|GATE EC 2022',
    image: wallImage,
  },
];


const WallOfFame = () => {
    const [wallOfFameData1, setwallOfFameData1] = useState([]);
    const [loading, setLoading] = useState(true);  // Handle loading state

    const fetchWallOfFame = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getWallOfFame`);
        setwallOfFameData1(response.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchWallOfFame();
    }, []); 


  const options = {
    loop: true,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 4 },
    },
  };

  return (
    <section className="wall_fame">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="site-heading text-left">
              <h2 className="site-title">Wall of Fame</h2>
            </div>
          </div>

          <OwlCarousel className="fame-slider owl-theme" {...options}>
            {wallOfFameData1.map((item, index) => (
              <div className="fame_cnt_all position-relative" key={index}>
                <div className="round_thumb">
                <img src={`${Image_Base_Url}${item.media_image_path}`} alt="media_image_path" />
                </div>
                <div className="fame_slider_item">
                  <p>{item.wall_fame}</p>
                  {/* <p className="nrm_title">{item.wall_fame_description}</p> */}
                  <p className="nrm_title" dangerouslySetInnerHTML={{ __html: item.wall_fame_description }} />
                </div>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>
    </section>
  );
};

export default WallOfFame;
